import { useParams, useNavigate } from "react-router-dom";
import { usePacientes } from "../context/PacientesContext";
import { useEffect, useState } from "react";
import { XCircle, ClipboardList, RefreshCw } from "lucide-react";
import VisualizacaoPaciente from "../components/VisualizacaoPaciente";

export default function ProntuarioPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { pacientes, loading, selecionarPaciente, pacienteSelecionado } =
    usePacientes();
  const [tentativas, setTentativas] = useState(0);
  const [pacienteEncontrado, setPacienteEncontrado] = useState(false);

  // Busca e seleciona o paciente quando os dados carregam
  useEffect(() => {
    if (loading) return;

    const paciente = pacientes.find((p) => p.id === id);

    if (paciente) {
      selecionarPaciente(paciente);
      setPacienteEncontrado(true);
    } else if (tentativas < 5) {
      // Tenta mais algumas vezes (pode haver delay na sincronização)
      const timer = setTimeout(() => {
        setTentativas((t) => t + 1);
      }, 500);
      return () => clearTimeout(timer);
    } else {
      // Não encontrou após várias tentativas
      console.warn("Paciente não encontrado após carregamento:", id);
      navigate("/");
    }
  }, [pacientes, loading, id, tentativas, selecionarPaciente, navigate]);

  // Mostra loading enquanto carrega
  if (loading || (!pacienteEncontrado && tentativas < 5)) {
    return (
      <div
        style={{
          width: "100vw",
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          gap: "16px",
          background: "linear-gradient(135deg, #2563eb 0%, #1e40af 100%)",
          color: "white",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        }}
      >
        <RefreshCw size={48} style={{ animation: "spin 1s linear infinite" }} />
        <div style={{ fontSize: "20px", fontWeight: "600" }}>
          Carregando prontuário...
        </div>
        <div style={{ fontSize: "14px", opacity: 0.8 }}>Aguarde um momento</div>
        <style>{`
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  if (!pacienteSelecionado) {
    return (
      <div
        style={{
          width: "100vw",
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#f3f4f6",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <XCircle size={48} color="#dc2626" style={{ marginBottom: "16px" }} />
          <div style={{ fontSize: "18px", color: "#374151" }}>
            Paciente não encontrado
          </div>
        </div>
      </div>
    );
  }

  // Renderiza o componente de visualização completo
  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        overflow: "auto",
        backgroundColor: "#f3f4f6",
      }}
    >
      {/* Header para nova aba */}
      <div
        style={{
          background: "linear-gradient(135deg, #2563eb 0%, #1e40af 100%)",
          color: "white",
          padding: "12px 24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          position: "sticky",
          top: 0,
          zIndex: 100,
          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <ClipboardList size={24} />
          <div>
            <div style={{ fontSize: "18px", fontWeight: "700" }}>
              {pacienteSelecionado.nome}
            </div>
            <div style={{ fontSize: "13px", opacity: 0.9 }}>
              CPF: {pacienteSelecionado.cpf}
            </div>
          </div>
        </div>
        <button
          onClick={() => window.close()}
          style={{
            background: "rgba(255,255,255,0.2)",
            border: "none",
            color: "white",
            width: "40px",
            height: "40px",
            borderRadius: "50%",
            fontSize: "20px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "all 0.2s",
          }}
          onMouseOver={(e) =>
            (e.currentTarget.style.background = "rgba(255,255,255,0.3)")
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.background = "rgba(255,255,255,0.2)")
          }
          title="Fechar aba"
        >
          ✕
        </button>
      </div>

      {/* Componente de visualização completo */}
      <div style={{ padding: "0" }}>
        <VisualizacaoPaciente />
      </div>
    </div>
  );
}
